import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useMemo,
} from "react";
import { View, StyleSheet, ViewStyle } from "react-native";

import Text from "./text";
import translate from "libs/locale";
import { OrderType } from "src/common/types/response/master";
import useMaster from "libs/hooks/useMaster";
import DateTimePicker from "./DateTimePicker";
import moment from "moment";
import { useDispatch } from "react-redux";
import { getServerTime } from "toolkit/features/master";
import Loader from "./loader";
import DeliveryTimeOptions from "./deliveryTimeOptions";
import { reportLog } from "../libs/utils/logs";

type Props = {
  containerStyle?: ViewStyle;
  defaultDeliveryType: OrderType;
  deliveryTypes: OrderType[];
  selectedDelivery: OrderType;
  selectedTime: number;
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  setSelectedTime: (time: number) => void;
  setSelectedDelivery: (type: OrderType) => void;
};
const DeliveryTime = (props: Props) => {
  const {
    containerStyle,
    defaultDeliveryType,
    deliveryTypes,
    selectedDelivery,
    selectedTime,
    selectedDate,
    setSelectedDate,
    setSelectedTime,
    setSelectedDelivery,
  } = props;

  const master = useMaster();
  const dispatch = useDispatch<any>();

  const [openDateTimePicker, setOpenDateTimePicker] = useState(false);
  const [serverTimeLoading, setServerTimeLoading] = useState(false);
  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState();
  const [selectedDeliveryTime, setSelectedDeliveryTime] = useState();
  const [serverTime, setServerTime] = useState<moment.Moment>(null);
  const timeSlots = master?.data?.payload?.time_slots || [];

  const getTime = () => {
    setServerTimeLoading(true);
    dispatch(getServerTime())
      .then((res) => {
        if (res?.payload?.payload) {
          setServerTime(moment.utc(parseInt(res?.payload?.payload)));
          setOpenDateTimePicker(true);
          setServerTimeLoading(false);
        }
      })
      .catch((err) => {
        reportLog({
          error: err,
          location: "deliveryTime[66]",
          body: {},
        });
        setServerTimeLoading(false);
      });
  };

  const onClick = (type: OrderType) => {
    setSelectedDelivery(type);
    if (type?.name.includes("SCHEDULED")) {
      getTime();
    } else {
      setServerTime(null);
      setSelectedDeliveryDate(null);
      setSelectedDeliveryTime(null);
    }
  };

  const onCloseDateTime = (selectedDate, selectedTime) => {
    if (!selectedDate) {
      setSelectedDelivery(defaultDeliveryType);
    }
    setSelectedDeliveryDate(selectedDate);
    setSelectedDeliveryTime(selectedTime);
    setOpenDateTimePicker(false);
    setServerTime(null);
  };

  return (
    <>
      <View style={[containerStyle]}>
        <View style={styles.header}>
          <Text style={styles.headerName}>{translate("delivery")}</Text>
        </View>
        <DeliveryTimeOptions
          types={deliveryTypes}
          selectedDeliveryDate={selectedDeliveryDate}
          timeSlots={timeSlots}
          selectedDeliveryTime={selectedDeliveryTime}
          selectedDelivery={selectedDelivery}
          onClick={onClick}
        />
      </View>
      <DateTimePicker
        open={openDateTimePicker}
        close={onCloseDateTime}
        serverTime={serverTime?.clone()}
        selectedDate={selectedDate}
        selectedTime={selectedTime}
        setSelectedDate={setSelectedDate}
        setSelectedTime={setSelectedTime}
      />
      {serverTimeLoading && <Loader full modal={false} loading />}
    </>
  );
};

const styles = StyleSheet.create({
  header: {
    borderBottomColor: "#F4F4F4",
    borderBottomWidth: 1,
    marginTop: 0,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 8,
  },
  headerName: {
    color: "#636E72",
    fontSize: 14,
    fontFamily: "MontserratBold",
  },
});

export default DeliveryTime;
